import { render, staticRenderFns } from "./servicedatails.vue?vue&type=template&id=0ab62eb2&scoped=true"
import script from "./servicedatails.vue?vue&type=script&lang=js"
export * from "./servicedatails.vue?vue&type=script&lang=js"
import style0 from "./servicedatails.vue?vue&type=style&index=0&id=0ab62eb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab62eb2",
  null
  
)

export default component.exports